import css from './valuePane.module.scss';
import cssPane from '../wordPane.module.scss';

import cx from 'classnames';
import { memo, useState } from 'react';

import { ImageResource } from 'com/ImageResource';
import { formatNote } from 'core/helpers/text';
import { useAutoFontSize } from 'core/helpers/useAutoFontSize';
import DisplayTemplate from 'core/ui/DisplayTemplate';
import LangIcon from 'core/ui/LangIcon';
import SpeechButton from 'core/ui/SpeechButton/SpeechButton';

import Transcription from './Transcription';

type TProps = {
  word: TWord;
  deck: TDeck;
  disabled: boolean;
  finished: boolean;
};

const ValuePaneDefault: React.FC<TProps> = ({
  word,
  deck,
  disabled,
  finished,
}) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  useAutoFontSize(container);

  return (
    <div
      className={cx(
        cssPane.wordSplitPane,
        css.valuePane,
        word.valueResourceUid && css.hyphenize
      )}
    >
      {deck.lang && <LangIcon className={css.langIcon} lang={deck.lang} />}

      <div
        className={css.body}
        ref={setContainer}
        lang={deck.lang ?? undefined}
      >
        <div className={css.value}>
          <DisplayTemplate children={word.value} />
        </div>

        {word.valueNote && (
          <div key="example" className={css.valueNote}>
            {formatNote(word.valueNote, finished)}
          </div>
        )}
      </div>

      {word.valueResourceUid && (
        <div className={css.image}>
          <ImageResource resourceUid={word.valueResourceUid} />
        </div>
      )}

      <Transcription transcription={word.transcription} />

      {deck.lang && (
        <SpeechButton
          className={css.speechButton}
          wordUid={word.uid}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default memo(ValuePaneDefault);
